import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import SafeFeedbackRankingGrid from './SafeFeedbackRankingGrid.jsx'
import { FormattedMessage, injectIntl } from 'react-intl'

class SafeFeedbackRanking extends Component {
	render() {
		return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
						<h3 className="content-header-title">
							<FormattedMessage id="SafeFeedbackRanking.label_ranking" defaultMessage="Ranking de Conductores" />
						</h3>
					</div>
				</div>
				<div className="content-body">
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={SafeFeedbackRankingGrid} />
					</Switch>
				</div>
			</div>
		)
	}
}

export default injectIntl(SafeFeedbackRanking)
